// removed by extract-text-webpack-plugin
module.exports = {"root":"root___2Qg-l"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/XiaoYuanHaoAuthorizeLayout.less
// module id = 05vM
// module chunks = 49